import React, { useMemo } from 'react';
import { connect } from 'umi';
import { ISingleCommonType, TOptionsItem } from '../../types';
import { useUpdateEffect } from 'ahooks';
import { SingleSelect, TSingleSelectType } from '../../components/SingleSelect';
import { singleMapStateToProps, singleMergeProps } from '../../connect/single';

export type HashtagSourceSelectType = TSingleSelectType & {
  filterOptions: (
    options: TOptionsItem[],
    filterValue: any,
  ) => TOptionsItem[];
};

function HashtagSourceSelect({
  options,
  change,
  filterValue,
  value,
  filterOptions,
  ...props
}: HashtagSourceSelectType & ISingleCommonType) {
  const realOptions = useMemo(() => {
    return filterOptions(options, filterValue);
  }, [filterValue.time_range]);

  useUpdateEffect(() => {
    if (value) {
      const index = realOptions.findIndex((item) => item.value === value);
      if (index === -1) {
        change(realOptions[0]?.value);
      }
    }
  }, [filterValue.time_range]);

  return (
    <SingleSelect
      filterValue={filterValue}
      change={change}
      value={value}
      options={realOptions}
      {...props}
    />
  );
}

export default connect(
  singleMapStateToProps,
  singleMergeProps,
)(HashtagSourceSelect);
